function checkIsDuplicate(record_id_to_be_duplicated, email, name, airtable_name,phone) {
    // console.log(name,email,phone)
    const raw = JSON.stringify({
        "name": name,
        "email": email,
        "airtable_name": airtable_name,
        "record_id_to_be_duplicated": record_id_to_be_duplicated,
        "phone":phone
    });
// console.log('Duplicate Raw Data', raw)
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: raw,
        redirect: "manual"
    };

    fetch("https://copy-lead.marke-ter.online/api/webhook/lead-check", requestOptions)
        .then((response) => response.text())
        .then((result) => console.log("Duplicate check result:", result))
        .catch((error) => console.error("Error in duplicate check:", error));
}